/**
 * Modal state machine.
 */
export const ModalState = {
	CLOSED: 'closed',
	OPENING: 'opening',
	LOADING: 'loading',
	LOADED: 'loaded',
	LOADED_SELECTED: 'loaded_selected',
	ADDING: 'adding',
	SUCCESS: 'success',
	ERROR: 'error',
	UNSUPPORTED: 'unsupported',
	UNAVAILABLE: 'unavailable',
	STOCK_ALERT: 'stock_alert',
};

export function createState() {
	return {
		state: ModalState.CLOSED,
		productId: null,
		context: 'archive',
		trigger: null,
		options: null,
		selectedVariationId: null,
		errorMessage: '',
		successMessage: '',
		adding: false,
	};
}
